import { useEffect } from "react"
import { getUserManager } from "./userManager"

/** Rendered in the hidden silent-renew iframe. Nothing user-visible happens here. */
export const SilentCallback = (): null => {
  useEffect(() => {
    getUserManager()
      .signinSilentCallback()
      .catch(() => undefined)
  }, [])

  return null
}
